enum ReferenceType {
  Floor = "FloorCheckInReference",
  Location = "LocationCheckInReference",
  CleaningObject = "CleaningObjectCheckInReference",
}

export default ReferenceType;
